import { z } from 'zod';
import { Role } from './user.interface';

// ============================================================================
// Login Schemas
// ============================================================================

export const LoginRequestSchema = z.object({
  email: z.string().email({ message: 'Invalid email address' }),
  password: z
    .string()
    .min(6, { message: 'Password must be at least 6 characters' }),
});

export type LoginRequest = z.infer<typeof LoginRequestSchema>;

export const LoginResponseSchema = z.object({
  id: z.string(),
  username: z.string(),
  accessToken: z.string(),
  avatarPath: z.string().optional(),
  role: z.enum(Role),
});

export type LoginResponse = z.infer<typeof LoginResponseSchema>;

// ============================================================================
// Register Schemas
// ============================================================================

export const RegisterRequestSchema = z.object({
  email: z.string().email({ message: 'Invalid email address' }),
  username: z
    .string()
    .min(3, { message: 'Username must be at least 3 characters' }),
  password: z
    .string()
    .min(6, { message: 'Password must be at least 6 characters' }),
});

export type RegisterRequest = z.infer<typeof RegisterRequestSchema>;

export const RegisterResponseSchema = z.object({
  id: z.string(),
  username: z.string(),
  accessToken: z.string(),
  avatarPath: z.string().optional(),
  role: z.enum(Role),
});

export type RegisterResponse = z.infer<typeof RegisterResponseSchema>;

// ============================================================================
// Confirm Email Schemas
// ============================================================================

export const ConfirmEmailSchema = z.object({
  code: z.string().min(1, { message: 'Code is required' }),
});

export type ConfirmEmailRequest = z.infer<typeof ConfirmEmailSchema>;

// ============================================================================
// Forgot Password Schemas
// ============================================================================

export const ForgotPasswordRequestSchema = z.object({
  email: z.email({ message: 'Invalid email address' }),
});

export type ForgotPasswordRequest = z.infer<typeof ForgotPasswordRequestSchema>;

// ============================================================================
// Reset Password Schemas
// ============================================================================

export const ResetPasswordRequestSchema = z.object({
  token: z.string().min(1, { message: 'Token is required' }),
  newPassword: z
    .string()
    .min(8, { message: 'Password must be at least 8 characters' }),
});

export type ResetPasswordRequest = z.infer<typeof ResetPasswordRequestSchema>;
